import React from 'react';
import ApexChart from 'react-apexcharts';
import type { Props as ReactApexChartProps } from 'react-apexcharts';

const ApexChartComponent =
  ApexChart as unknown as React.ComponentType<ReactApexChartProps>;

export default function ReactApexChartCompat(props: ReactApexChartProps) {
  return <ApexChartComponent {...props} />;
}
